export default "__VITE_ASSET__BI20KtU8__"